// @em/utils/analyticsPrivacy
//
// WHAT MAY LEAVE FOR GOOGLE (ROADMAP #62 P7) — shared by the app and the marketing websites (A10.5). GA reads the page's
// full URL into every hit unless told otherwise, and links can carry a SECRET in the query string (the app's `?token=`
// and `?inv=`). Moved here from apps/app `src/utils/analytics/privacy.ts`, which re-exports it.
//
// ⚠ An ALLOW-list, not a deny-list: a new secret-bearing parameter must not need remembering here. Only the campaign
//   tags GA reads for attribution survive.
// ⚠ Pure, so `check-analytics` RUNS it.

const KEPT_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id', 'gclid'];

/** The URL as GA may see it: origin + path, campaign tags only, no hash. An unparseable URL becomes the bare origin. */
export const safePageLocation = (href: string): string => {
  try {
    const url = new URL(href);
    const kept = new URLSearchParams();

    KEPT_PARAMS.forEach((name) => {
      const value = url.searchParams.get(name);

      if (value != null) {
        kept.set(name, value);
      }
    });

    const query = kept.toString();

    return `${url.origin}${url.pathname}${query ? `?${query}` : ''}`;
  } catch {
    return '';
  }
};
